import { StyleSheet } from 'react-native'
import theme from '../../../../theme'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
        width: '100%',
    },
    flexDirectionRow: {
        flexDirection: 'row',
    },
    image: {
        marginRight: 12,
        width: 80,
        height: 80,
        borderRadius: 5,
    },
    containerData: {
        flex: 1,
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginBottom: 8,
    },
    title: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingHorizontal: 0,
    },
    description: {
        fontSize: 13,
        color: theme.colors.textSecondary,
        textAlign: 'left',
        paddingBottom: 5,
        paddingHorizontal: 0,
    },
    inputRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 44,
        borderRadius: 8,
        backgroundColor: 'white',
        paddingHorizontal: 12,
        marginTop: 5,
    },
    inputText: {
        fontSize: 15,
        color: theme.colors.textPrimary,
    },
    placeholderText: {
        color: theme.colors.inputPlaceholder,
    },
})

export default styles
